// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3hN-J","emails":"CreateEditClinics_emails__1msuI","emailTagLabel":"CreateEditClinics_emailTagLabel__2iKVl"};